"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLogsSettings = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Log = require("../../constants/Log");
var _DmsForm = require("../DmsForm/DmsForm");
var _DmsSelect = require("../DmsSelect/DmsSelect");
var _DmsSwitch = require("../DmsSwitch/DmsSwitch");
var _DmsTextField = require("../DmsTextField/DmsTextField");
var _material = require("@mui/material");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _DmsLoading = require("../DmsLoading/DmsLoading");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DmsLogsSettings = () => {
  var _logSettingData$statu, _logSettingData$min_l, _logSettingData$statu2, _logSettingData$limit, _logSettingData$limit2, _logSettingData$hour_, _logSettingData$reque, _logSettingData$size_;
  const [logSettingData, setLogSettingData] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const fetchLogSetting = async () => {
      try {
        var _data$data;
        const url = "/log_settings";
        const {
          data
        } = await (0, _DmsFetch.fetchData)(url, "GET", true);
        setLogSettingData((_data$data = data === null || data === void 0 ? void 0 : data.data) !== null && _data$data !== void 0 ? _data$data : null);
      } catch (error) {
        console.error("Error fetching ".concat(url, ": ").concat(error));
      }
    };
    fetchLogSetting();
  }, []);
  const handleChange = (name, value) => {
    setLogSettingData(prevData => _objectSpread(_objectSpread({}, prevData), {}, {
      [name]: value
    }));
  };
  if (!logSettingData) {
    return /*#__PURE__*/_react.default.createElement(_DmsLoading.DmsLoading, null);
  }
  const logLevelOptions = Object.keys(_Log.LogLevel).map(key => ({
    label: key,
    value: _Log.LogLevel[key]
  }));
  return /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm, {
    url: "/log_settings",
    method: "PUT",
    fieldTypes: {
      min_log_level: "int",
      limit_to_keep_for_time: "int",
      limit_to_keep_for_quantity: "int",
      status_for_time: "bool",
      status_for_quantity: "bool",
      hour_threshold: "int",
      request_wait_time: "int",
      size_of_log_list: "int"
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm.Body, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSwitch.DmsSwitch, {
    name: "status_for_time",
    label: _reactIntlUniversal.default.get("Deletelogsbymonths").d("Delete logs by months"),
    checked: (_logSettingData$statu = logSettingData === null || logSettingData === void 0 ? void 0 : logSettingData.status_for_time) !== null && _logSettingData$statu !== void 0 ? _logSettingData$statu : false,
    onChange: value => handleChange("status_for_time", value),
    required: true
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 8,
    md: 8,
    lg: 8
  }, /*#__PURE__*/_react.default.createElement(_DmsSelect.DmsSelect, {
    name: "min_log_level",
    label: _reactIntlUniversal.default.get("LogLevel").d("Log Level"),
    options: logLevelOptions,
    fullWidth: true,
    value: (_logSettingData$min_l = logSettingData === null || logSettingData === void 0 ? void 0 : logSettingData.min_log_level) !== null && _logSettingData$min_l !== void 0 ? _logSettingData$min_l : "",
    onChange: selectedOption => handleChange("min_log_level", selectedOption),
    required: true
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSwitch.DmsSwitch, {
    name: "status_for_quantity",
    label: _reactIntlUniversal.default.get("Deletelogsbyquantity").d("Delete logs by quantity"),
    checked: (_logSettingData$statu2 = logSettingData === null || logSettingData === void 0 ? void 0 : logSettingData.status_for_quantity) !== null && _logSettingData$statu2 !== void 0 ? _logSettingData$statu2 : false,
    onChange: value => handleChange("status_for_quantity", value),
    required: true
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "limit_to_keep_for_time",
    label: _reactIntlUniversal.default.get("Monthstokeeplogs").d("Months to keep logs"),
    fullWidth: true,
    value: (_logSettingData$limit = logSettingData === null || logSettingData === void 0 ? void 0 : logSettingData.limit_to_keep_for_time) !== null && _logSettingData$limit !== void 0 ? _logSettingData$limit : "",
    onChange: e => handleChange("limit_to_keep_for_time", e.target.value),
    required: true
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "limit_to_keep_for_quantity",
    label: _reactIntlUniversal.default.get("Numberofthequantityoflogstobekeep").d("Number of the quantity of logs to be kept"),
    fullWidth: true,
    value: (_logSettingData$limit2 = logSettingData === null || logSettingData === void 0 ? void 0 : logSettingData.limit_to_keep_for_quantity) !== null && _logSettingData$limit2 !== void 0 ? _logSettingData$limit2 : "",
    onChange: e => handleChange("limit_to_keep_for_quantity", e.target.value),
    required: true
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "hour_threshold",
    label: _reactIntlUniversal.default.get("HourThreshold").d("Hour threshold"),
    fullWidth: true,
    value: (_logSettingData$hour_ = logSettingData === null || logSettingData === void 0 ? void 0 : logSettingData.hour_threshold) !== null && _logSettingData$hour_ !== void 0 ? _logSettingData$hour_ : "",
    onChange: e => handleChange("hour_threshold", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "request_wait_time",
    label: _reactIntlUniversal.default.get("RequestWaitTime").d("Request wait time"),
    fullWidth: true,
    value: (_logSettingData$reque = logSettingData === null || logSettingData === void 0 ? void 0 : logSettingData.request_wait_time) !== null && _logSettingData$reque !== void 0 ? _logSettingData$reque : "",
    onChange: e => handleChange("request_wait_time", e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsTextField.DmsTextField, {
    name: "size_of_log_list",
    label: _reactIntlUniversal.default.get("SizeOfLogList").d("Size of log list"),
    fullWidth: true,
    value: (_logSettingData$size_ = logSettingData === null || logSettingData === void 0 ? void 0 : logSettingData.size_of_log_list) !== null && _logSettingData$size_ !== void 0 ? _logSettingData$size_ : "",
    onChange: e => handleChange("size_of_log_list", e.target.value)
  })))));
};
exports.DmsLogsSettings = DmsLogsSettings;